import React from "react";
import { CompanyContainer } from "../styled/setting";

const Company = ({ company }) => {
  return (
    <CompanyContainer>
      <img
        src={imgHandler(company?.cmpnyImage)}
        alt={company?.cmpnyNm}
        onError={(e) => (e.target.src = "/img/logo.png")}
      />
      <span>{company?.cmpnyNm}</span>
    </CompanyContainer>
  );
};

export default Company;
